import FreemiumEventTutorialWaldofiedUpsellStep from './FreemiumEventTutorialWaldofiedUpsellStep';

export default FreemiumEventTutorialWaldofiedUpsellStep;
